<template>

    <div class="container">
        <h1>{{ __('Produktdaten importieren') }}</h1>

        <p class="lead">
            {{ __('Bitte wählen Sie eine CSV-Datei aus.') }}
        </p>

        <form @submit.prevent="form.post(route('admin.products.import-submit'))">

            <div class="mb-4">
                <div>
                    <label for="csv_file" class="form-label">{{ __('CSV file') }}</label>
                    <input class="form-control form-control-lg" :class="{ 'is-invalid': form.errors.csv_file }" id="csv_file" type="file" accept=".csv" @input="change" />
                    <div v-if="form.errors.csv_file" class="invalid-feedback">{{ form.errors.csv_file }}</div>
                </div>

                <progress class="w-100" v-if="form.progress" :value="form.progress.percentage" max="100">
                    {{ form.progress.percentage }}%
                </progress>

            </div>

            <submit-button :form="form" />

        </form>

    </div>

</template>

<script>
    import FileInput from '@/shared/Inputs/FileInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'user',
            'countries',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    csv_file: null,
                }),
            }
        },
        components: {
            FileInput,
            SubmitButton,
        },
        watch: {
        },
        methods: {
            change(e) {
                const file = e.target.files[0];
                this.form.csv_file = file;
            },
        },
    }
</script>